import type {PhotoContext} from './contracts';
import {photoDetailPath} from './usePhotoCollection';
export function deerReviewPath(photoId:string,context:PhotoContext,subjectId:string,returnTo?:string){
 return '/photos/'+encodeURIComponent(photoId)+'/deer-review?'+new URLSearchParams({context:JSON.stringify(context),subject:subjectId,...(returnTo?{returnTo}:{})});
}
export function deerReviewReturn(photoId:string,context:PhotoContext,raw:string|null){
 const fallback=photoDetailPath({context,search:'',order:'newest',tagIds:[]},photoId);
 if(!raw||raw.length>6000||!raw.startsWith('/')||raw.startsWith('//')||/[\\\u0000-\u001f]/.test(raw))return fallback;
 try{const url=new URL(raw,'https://photo.local');if(url.origin==='https://photo.local'&&!url.hash&&url.pathname===fallback)return url.pathname+url.search;}catch{/* Invalid hints never manufacture a collection. */}
 return fallback;
}
